<template>
  <section
    id="logos"
    class="logo-section"
  >
    <div class="container">
      <h1>Top companies want to work with you</h1>
    </div>
    <div
      class="marquee"
      :class="{ container: isMobile }"
    >
      <div class="track">
        <div
          v-for="(logo, index) in logos?.firstSectionLogos || []"
          :key="`logo1-${index}`"
          class="logo"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>

        <div
          v-for="(logo, index) in logos?.secondSectionLogos || []"
          :key="`logo2-${index}`"
          class="logo"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>

        <div
          v-for="(logo, index) in logos?.firstSectionLogos || []"
          :key="`logo3-${index}`"
          class="logo"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>

        <div
          v-for="(logo, index) in logos?.secondSectionLogos || []"
          :key="`logo4-${index}`"
          class="logo"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import isMobile from '~/mixins/responsive';

export default {
  mixins: [isMobile],

  props: {
    logos: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './LogoSection.scss';
</style>
